export default __webpack_public_path__ + "c742a68de548b26a813652984e254093.png";